import { css, type FC } from "dreamland/core";
import { Icon } from "@components/Icon";
import { closeMenu } from "@components/Menu";
import { iconClose, iconFolder, iconOpen, iconPause } from "../icons";
import { formatBytes } from "../util";
import { INTERNAL_URL_PROTOCOL } from "../consts";
import { Button } from "@components/Button";
import { Favicon } from "@components/Favicon";
import { downloadsService, tabsService } from "..";

export function DownloadsPopup() {
	return (
		<div>
			<div class="title">
				<span>Recent Downloads</span>
				<div class="buttoniconcontainer">
					<Button
						variant="icon"
						on:click={() => {
							closeMenu();
						}}
					>
						<Icon icon={iconClose}></Icon>
					</Button>
				</div>
			</div>
			<div class="entries">
				{use(downloadsService.sessionDownloadHistory).mapEach((b) => (
					<div class="entry">
						<div class="iconcontainer">
							<Favicon domain={new URL(b.url).hostname} size="medium"></Favicon>
						</div>
						<div class="contents">
							<span>{b.filename}</span>
							{use(b.progressbytes)
								.and(
									<span class="data">
										{use(b.progressbytes).map((s) => formatBytes(s!))}/
										{formatBytes(b.size)}
									</span>
								)
								.or(<span class="data">{formatBytes(b.size)}</span>)}
						</div>
						<div class="buttoniconcontainer">
							{use(b.progress)
								.and(
									<>
										<Button
											variant="icon"
											on:click={() => {
												b.pause!();
											}}
										>
											<Icon icon={iconPause}></Icon>
										</Button>
										<Button
											variant="icon"
											on:click={() => {
												b.cancel!();
											}}
										>
											<Icon icon={iconClose}></Icon>
										</Button>
									</>
								)
								.or(
									<>
										<Button variant="icon">
											<Icon icon={iconFolder}></Icon>
										</Button>
										<Button variant="icon">
											<Icon icon={iconOpen}></Icon>
										</Button>
									</>
								)}
						</div>
						{use(b.progress).and(
							<progress value={use(b.progress).map((p) => p || 0)} max="1">
								50%
							</progress>
						)}
					</div>
				))}
			</div>
			<div
				class="footer"
				on:click={() => {
					tabsService.newTab(new URL(`${INTERNAL_URL_PROTOCOL}//downloads`));
					closeMenu();
				}}
			>
				<span>Full Download History</span>
				<div class="buttoniconcontainer">
					<Icon icon={iconOpen}></Icon>
				</div>
			</div>
		</div>
	);
}
DownloadsPopup.style = css`
	:scope {
		width: 20em;
		display: flex;
		flex-direction: column;
		user-select: none;
	}

	.title {
		padding: var(--space-xl);
		display: flex;
		border-bottom: 1px solid var(--text-30);
	}
	.title p {
		font-size: 1.25em;
	}
	.title button {
		display: flex;
		align-items: center;
		font-size: 1em;
		position: relative;
	}
	.title button:hover::before {
		content: "";
		z-index: -1;
		position: absolute;
		width: 150%;
		height: 150%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: var(--text-15);
		border-radius: 50%;
	}

	.entries {
		max-height: 30em;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.entry {
		padding: var(--space-xl);
		display: flex;
		gap: var(--space-xl);
		font-size: 0.9em;
		position: relative;
	}
	.entry:hover {
		background: var(--text-15);
	}
	.contents {
		display: flex;
		overflow: hidden;
		flex-direction: column;
		gap: var(--space-md);
	}
	.entry .buttoniconcontainer {
		display: none;
	}
	.entry:hover .buttoniconcontainer {
		display: flex;
	}
	.entry .buttoniconcontainer {
		position: absolute;
		right: 0;
		top: 0;
		padding: var(--space-xl);
		background: var(--text-15);
		height: 100%;
		align-items: start;
		gap: var(--space-xl);
	}
	.entry .buttoniconcontainer button {
		font-size: 1.15em;
		position: relative;
		z-index: 1;
		display: flex;
	}
	.entry .buttoniconcontainer button:hover::before {
		content: "";
		z-index: -1;
		position: absolute;
		width: 150%;
		height: 150%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: var(--text-30);
		border-radius: 50%;
	}

	.contents .data {
		color: var(--text-70);
	}
	.footer {
		border-top: 1px solid var(--text-30);
		padding: var(--space-xl);
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.footer:hover {
		background: var(--text-15);
	}
	.buttoniconcontainer {
		flex: 1;
		display: flex;
		justify-content: right;
	}
	progress {
		z-index: 1;
		position: absolute;
		bottom: -0.25em;
		left: 2em;
		margin: var(--space-md);
		width: calc(100% - 4em);
		height: 0.25em;
		border: none;
	}
	progress::-webkit-progress-bar {
		background-color: var(--text-30);
		border-radius: var(--radius-md);
	}
	progress::-webkit-progress-value {
		background-color: var(--tab_line);
		border-radius: var(--radius-md);
	}
`;
